import React, { useState } from "react";
import { PanelWithHeader } from "../panels/PanelWithHeader";
import "./ShoppingAddOrUpdatePopup.css";

interface Props {
  handleClose: any;
  handleConfirmation: any;
}

export const ShoppingAddOrUpdatePopup = (props: Props) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    category: "Potraviny a pití",
    subCategory: "Mléčné výrobky",
  });

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        className="overlay"
        id="popupOverlay"
        style={{ display: "block" }}
      ></div>
      <div className="popup">
        <PanelWithHeader
          header="Přidání nové položky"
          iconClassName="fas fa-shopping-cart"
        >
          <div className="form-outline">
            <label className="form-label" htmlFor="name">
              Název
            </label>
            <input
              type="text"
              id="name"
              defaultValue={formData.name}
              onChange={(event) => {
                setFormData({ ...formData, name: event.target.value });
              }}
              className="form-control"
            />
          </div>
          <div className="form-outline">
            <label className="form-label" htmlFor="description">
              Popis
            </label>
            <textarea
              id="description"
              defaultValue={formData.description}
              onChange={(event) => {
                setFormData({ ...formData, description: event.target.value });
              }}
              rows={5}
              className="form-control"
            />
          </div>
          <div className="form-outline">
            <label className="form-label" htmlFor="category">
              Kategorie
            </label>
            <select
              defaultValue={formData.category}
              onChange={(event) => {
                setFormData({ ...formData, category: event.target.value });
              }}
              name="category"
              className="form-control"
            >
              <option value="Dům">Dům</option>
              <option value="Garáž">Garáž</option>
              <option value="Osobní">Osobní</option>
              <option value="Crit">Crit</option>
              <option value="Auto">Auto</option>
            </select>
          </div>
          <div className="form-outline">
            <label className="form-label" htmlFor="subCategory">
              Pod kategorie
            </label>
            <select
              defaultValue={formData.category}
              onChange={(event) => {
                setFormData({ ...formData, category: event.target.value });
              }}
              name="subCategory"
              className="form-control"
            >
              <option value="Dům">Dům</option>
              <option value="Garáž">Garáž</option>
              <option value="Osobní">Osobní</option>
              <option value="Crit">Crit</option>
              <option value="Auto">Auto</option>
            </select>
          </div>
          <div className="operations" style={{ textAlign: "center" }}>
            <input
              type="button"
              style={{ fontSize: "16px" }}
              className="btn btn-sm btn-primary"
              value="Ok"
              onClick={() => {
                props.handleConfirmation(formData);
              }}
            />
            <input
              type="button"
              style={{ fontSize: "16px" }}
              className="btn btn-sm btn-warning"
              value="Storno"
              onClick={() => {
                props.handleClose();
              }}
            />
          </div>
        </PanelWithHeader>
      </div>
    </div>
  );
};
